(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const drawerAnimationDuration = 280;

  const openMobileMenu = (menu) => {
    if (!menu || menu.hasAttribute('open')) return;

    menu.setAttribute('open', '');
    menu.classList.remove('is-closing');
    menu.closest('.trufit-header')?.classList.add('is-menu-open');
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => menu.classList.add('is-open'));
    });
  };

  const closeMobileMenu = (menu, restoreFocus = true) => {
    if (!menu || !menu.hasAttribute('open') || menu.classList.contains('is-closing')) return;

    const summary = menu.querySelector(':scope > summary');
    menu.classList.add('is-closing');
    menu.classList.remove('is-open');
    document.documentElement.style.overflow = '';

    window.setTimeout(() => {
      menu.removeAttribute('open');
      menu.classList.remove('is-closing');
      menu.closest('.trufit-header')?.classList.remove('is-menu-open');
      if (restoreFocus) summary?.focus();
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : drawerAnimationDuration);
  };

  document.addEventListener('click', (event) => {
    const menuSummary = event.target.closest('[data-header-mobile-menu] > summary');

    if (menuSummary) {
      event.preventDefault();
      const menu = menuSummary.closest('[data-header-mobile-menu]');
      if (menu.hasAttribute('open')) {
        closeMobileMenu(menu);
      } else {
        openMobileMenu(menu);
      }
      return;
    }

    const closeButton = event.target.closest('[data-header-menu-close]');

    if (closeButton) {
      closeMobileMenu(closeButton.closest('[data-header-mobile-menu]'));
      return;
    }

    if (event.target.classList.contains('trufit-header__drawer')) {
      closeMobileMenu(event.target.closest('[data-header-mobile-menu]'));
      return;
    }

    document
      .querySelectorAll('.trufit-header__nav-dropdown[open], .trufit-header__drawer-dropdown[open]')
      .forEach((dropdown) => {
        if (!dropdown.contains(event.target)) {
          dropdown.removeAttribute('open');
        }
      });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-header-mobile-menu][open]').forEach((menu) => closeMobileMenu(menu));

    document
      .querySelectorAll('.trufit-header__nav-dropdown[open], .trufit-header__drawer-dropdown[open]')
      .forEach((dropdown) => {
        dropdown.removeAttribute('open');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHowItWorks = (root) => {
      if (!root || root.dataset.howItWorksInitialized === 'true') return;

      const track = root.querySelector('.trufit-how__cards');
      const buttons = [...root.querySelectorAll('[data-how-slide-index]')];
      const cards = [...root.querySelectorAll('.trufit-how__card')];

      if (!track || cards.length < 2 || buttons.length !== cards.length) return;

      root.dataset.howItWorksInitialized = 'true';

      let scrollFrame = null;

      const setActive = (index) => {
        buttons.forEach((button, buttonIndex) => {
          const isActive = buttonIndex === index;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', String(isActive));
        });
      };

      const getClosestCardIndex = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;

        return cards.reduce((closestIndex, card, index) => {
          const closestCard = cards[closestIndex];
          const closestDistance = Math.abs(
            closestCard.offsetLeft + closestCard.offsetWidth / 2 - trackCenter
          );
          const distance = Math.abs(
            card.offsetLeft + card.offsetWidth / 2 - trackCenter
          );

          return distance < closestDistance ? index : closestIndex;
        }, 0);
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.howSlideIndex);
          const card = cards[index];

          if (!card) return;

          const centeredLeft =
            card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;

          track.scrollTo({
            left: Math.max(0, centeredLeft),
            behavior: 'smooth',
          });
          setActive(index);
        });
      });

      track.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(() => {
            setActive(getClosestCardIndex());
            scrollFrame = null;
          });
        },
        { passive: true }
      );

      setActive(0);
    };

    const initialize = (scope = document) => {
      if (scope instanceof Element && scope.matches('.trufit-how')) {
        initializeHowItWorks(scope);
      }

      scope.querySelectorAll?.('.trufit-how').forEach(initializeHowItWorks);
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-product-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));
    const dots = Array.from(gallery.querySelectorAll('[data-product-gallery-dot]'));
    const hero = gallery.querySelector('.trufit-main-product__media--hero img');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const source = thumb.getAttribute('data-hero-src');
        if (!desktopQuery.matches || !hero || !source) return;
        hero.removeAttribute('srcset');
        hero.removeAttribute('sizes');
        hero.src = source;
        hero.alt = thumb.getAttribute('data-hero-alt') || hero.alt;
        thumbs.forEach((node) => node.classList.toggle('is-active', node === thumb));
      });
    });

    if (!track || slides.length < 2 || dots.length < 2) return;

    const setActiveDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slide = slides[index];
        if (!slide) return;

        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        setActiveDot(index);
      });
    });

    let animationFrame = 0;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActiveDot(Math.max(0, Math.min(index, dots.length - 1)));
      });
    });
  });

  const productDescriptionSelector = '[data-product-description]';
  const productDescriptionTextSelector = 'p, h1, h2, h3, h4, h5, h6, li';
  const productDescriptionOverflowTolerance = 1;
  const productDescriptionTransitionDuration = 220;
  const productDescriptionWrappers = new Set();
  const productDescriptionMobileQuery = window.matchMedia('(max-width: 749px)');

  const getProductDescriptionLineHeight = (content) => {
    const lineHeight = Number.parseFloat(window.getComputedStyle(content).lineHeight);

    return Number.isFinite(lineHeight) ? Math.ceil(lineHeight) : 20;
  };

  const getProductDescriptionFirstTextRect = (content) => {
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => (node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    let textNode = walker.nextNode();

    while (textNode) {
      const range = document.createRange();
      range.selectNodeContents(textNode);

      const textRect = Array.from(range.getClientRects()).find((rect) => rect.width > 0 && rect.height > 0);

      range.detach?.();

      if (textRect) return textRect;

      textNode = walker.nextNode();
    }

    return null;
  };

  const getProductDescriptionCollapsedHeight = (content) => {
    const lineHeight = getProductDescriptionLineHeight(content);
    const contentRect = content.getBoundingClientRect();
    const firstTextRect = getProductDescriptionFirstTextRect(content);

    if (!firstTextRect) return lineHeight;

    const firstTextBottom = Math.ceil(firstTextRect.bottom - contentRect.top);

    return Math.max(lineHeight, firstTextBottom);
  };

  const measureProductDescription = (content) => {
    const width = content.clientWidth || content.getBoundingClientRect().width;
    const clone = content.cloneNode(true);

    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    clone.classList.add('is-expanded');
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.left = '0';
    clone.style.top = '0';
    clone.style.width = `${width}px`;
    clone.style.height = 'auto';
    clone.style.maxHeight = 'none';
    clone.style.overflow = 'visible';
    clone.style.transition = 'none';

    content.after(clone);

    const collapsedHeight = getProductDescriptionCollapsedHeight(clone);
    const measuredNodes = [clone, ...clone.querySelectorAll(productDescriptionTextSelector)];
    const hasHorizontalOverflow = measuredNodes.some(
      (node) => node.scrollWidth - node.clientWidth > productDescriptionOverflowTolerance
    );
    const expandedHeight = Math.ceil(clone.scrollHeight);
    const hasVerticalOverflow = expandedHeight - collapsedHeight > productDescriptionOverflowTolerance;

    clone.remove();

    return {
      collapsedHeight,
      expandedHeight: Math.max(expandedHeight, collapsedHeight),
      isCollapsible: hasHorizontalOverflow || hasVerticalOverflow,
    };
  };

  const updateProductDescriptionToggle = (content, toggle, isExpanded = content.classList.contains('is-expanded')) => {
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    toggle.textContent = isExpanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
  };

  const applyProductDescriptionMeasurement = (content, measurement) => {
    content.style.setProperty('--trufit-product-description-collapsed-height', `${measurement.collapsedHeight}px`);
    content.style.setProperty('--trufit-product-description-expanded-height', `${measurement.expandedHeight}px`);
  };

  const animateProductDescription = (content, shouldExpand, measurement) => {
    const startHeight = shouldExpand ? measurement.collapsedHeight : measurement.expandedHeight;
    const endHeight = shouldExpand ? measurement.expandedHeight : measurement.collapsedHeight;

    if (typeof content.trufitDescriptionTransitionCleanup === 'function') {
      content.trufitDescriptionTransitionCleanup();
    }

    content.classList.toggle('is-expanded', !shouldExpand);
    content.style.maxHeight = `${startHeight}px`;
    // Force layout so max-height animates from the explicit start height.
    content.offsetHeight;
    content.classList.add('is-expanded');
    content.style.maxHeight = `${endHeight}px`;

    let cleanupTimeout = 0;
    const cleanup = () => {
      window.clearTimeout(cleanupTimeout);
      content.removeEventListener('transitionend', onTransitionEnd);
      content.classList.toggle('is-expanded', shouldExpand);
      content.style.maxHeight = '';
      content.trufitDescriptionTransitionCleanup = null;
    };
    const onTransitionEnd = (event) => {
      if (event.target === content && event.propertyName === 'max-height') {
        cleanup();
      }
    };

    cleanupTimeout = window.setTimeout(cleanup, productDescriptionTransitionDuration + 80);
    content.trufitDescriptionTransitionCleanup = cleanup;
    content.addEventListener('transitionend', onTransitionEnd);
  };

  const syncProductDescription = (wrapper) => {
    const content = wrapper.querySelector('[data-product-description-content]');
    const toggle = wrapper.querySelector('[data-product-description-toggle]');

    if (!content || !toggle) return;

    const measurement = measureProductDescription(content);
    const isCollapsible = productDescriptionMobileQuery.matches && measurement.isCollapsible;

    applyProductDescriptionMeasurement(content, measurement);
    wrapper.classList.toggle('is-collapsible', isCollapsible);
    toggle.hidden = !isCollapsible;

    if (!isCollapsible) {
      content.classList.remove('is-expanded');
    }

    updateProductDescriptionToggle(content, toggle);
  };

  const toggleProductDescription = (wrapper) => {
    const content = wrapper.querySelector('[data-product-description-content]');
    const toggle = wrapper.querySelector('[data-product-description-toggle]');

    if (!content || !toggle || !wrapper.classList.contains('is-collapsible')) return;

    const measurement = measureProductDescription(content);
    const isExpanded = content.classList.contains('is-expanded');

    applyProductDescriptionMeasurement(content, measurement);
    animateProductDescription(content, !isExpanded, measurement);
    updateProductDescriptionToggle(content, toggle, !isExpanded);
  };

  const syncProductDescriptions = () => {
    productDescriptionWrappers.forEach(syncProductDescription);
  };

  const scheduleProductDescriptionSync = (() => {
    let animationFrame = 0;

    return () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(syncProductDescriptions);
    };
  })();

  const initProductDescriptions = (root = document) => {
    root.querySelectorAll(productDescriptionSelector).forEach((wrapper) => {
      const content = wrapper.querySelector('[data-product-description-content]');
      const toggle = wrapper.querySelector('[data-product-description-toggle]');

      if (!content || !toggle) return;

      productDescriptionWrappers.add(wrapper);

      if (wrapper.dataset.productDescriptionInitialized !== 'true') {
        wrapper.dataset.productDescriptionInitialized = 'true';
        toggle.addEventListener('click', () => {
          toggleProductDescription(wrapper);
        });
      }

      syncProductDescription(wrapper);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initProductDescriptions();
    });
  } else {
    initProductDescriptions();
  }

  window.addEventListener('resize', scheduleProductDescriptionSync);
  document.fonts?.ready.then(scheduleProductDescriptionSync).catch(() => {});
  document.addEventListener('shopify:section:load', (event) => {
    initProductDescriptions(event.target);
  });

  document.querySelectorAll('[data-product-review-summary]').forEach((summary) => {
    const rating = Number(summary.dataset.reviewRating);
    const ratingNode = summary.querySelector('[data-product-review-rating]');

    if (ratingNode && Number.isFinite(rating)) {
      ratingNode.textContent = rating.toFixed(1);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  const initializeJudgeMeReviewSection = (section) => {
    if (!(section instanceof HTMLElement) || section.dataset.reviewsInitialized === 'true') return;

    const track = section.querySelector('[data-reviews-track]');
    const navigation = section.querySelector('[data-reviews-nav]');
    const previousButton = section.querySelector('[data-reviews-previous]');
    const nextButton = section.querySelector('[data-reviews-next]');
    const position = section.querySelector('[data-reviews-position]');
    const apiUrl = section.dataset.reviewsApiUrl || '';
    // Reviews the team chose not to show (theme setting "Reviews to hide").
    const hiddenReviewIds = (section.dataset.reviewsHiddenIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    const productId = section.dataset.reviewsProductId || '';
    const productHandle = section.dataset.reviewsProductHandle || '';
    const fallbackProductId = section.dataset.reviewsFallbackProductId || '';
    const fallbackProductHandle = section.dataset.reviewsFallbackProductHandle || '';
    const perPage = Math.max(1, Number(section.dataset.reviewsPerPage) || 16);
    const minRating = Math.max(1, Number(section.dataset.minRating) || 4);
    const configuredProductIds = (section.dataset.reviewsProductIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    const starUrl = section.dataset.reviewsStarUrl || '';
    const checkUrl = section.dataset.reviewsCheckUrl || '';
    const anonymousLabel = section.dataset.reviewsAnonymous || '';
    // Show "First L." so reviewers' full last names are not published.
    const formatReviewerName = (name) => {
      const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
      if (parts.length < 2) return parts.join('');
      const initial = parts[parts.length - 1].replace(/[^0-9A-Za-z\u00C0-\u024F]/g, '').charAt(0);
      return initial ? parts[0] + ' ' + initial.toUpperCase() + '.' : parts[0];
    };
    const productFallbackLabel = section.dataset.reviewsProductFallback || '';
    const shortTagNames = (section.dataset.reviewsTagShort || '')
      .split(/[\n,]/)
      .map((pair) => pair.split('='))
      .filter((pair) => pair.length === 2 && pair[0].trim() && pair[1].trim())
      .map((pair) => [pair[0].trim().toLowerCase(), pair[1].trim()]);
    const shortTagName = (title) => {
      const key = String(title || '').trim().toLowerCase();
      const found = shortTagNames.find((pair) => pair[0] === key);
      return found ? found[1] : title;
    };
    const verifiedLabel = section.dataset.reviewsVerifiedLabel || '';
    const ratingLabelTemplate = section.dataset.reviewsRatingLabel || '__rating__';
    const positionLabelTemplate = section.dataset.reviewsPositionLabel || '__start__–__end__';
    const summary = section.querySelector('[data-reviews-summary]');
    const eyebrow = section.querySelector('[data-reviews-eyebrow]');
    const isWall = section.dataset.reviewsLayout === 'wall';

    if (!(track instanceof HTMLElement)) return;

    section.dataset.reviewsInitialized = 'true';

    if (summary instanceof HTMLElement) {
      const rating = Number(summary.dataset.reviewsSummaryRating);
      const count = Number(summary.dataset.reviewsSummaryCount);
      const locale = document.documentElement.lang || 'en';
      const ratingText = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(rating);
      const countText = new Intl.NumberFormat(locale).format(count) + (summary.hasAttribute('data-reviews-summary-plus') && count > 1 ? '+' : '');
      const template = count === 1
        ? summary.dataset.reviewsSummaryTemplateOne
        : summary.dataset.reviewsSummaryTemplate;

      summary.textContent = (template || '__rating__ • __count__')
        .replace('__rating__', ratingText)
        .replace('__count__', countText);

      if (eyebrow instanceof HTMLElement) {
        eyebrow.textContent = (eyebrow.dataset.reviewsEyebrowTemplate || '__count__').replace('__count__', countText);
      }
    }

    let apiPage = 1;
    let animationFrame = 0;
    let cards = [];
    let hasMore = false;
    let isLoading = false;
    let activeScopedProductId = '';
    const prefetchSlidesThreshold = 2;

    const createImage = ({
      alt = '',
      className = '',
      height,
      sizes = '',
      src,
      srcset = '',
      width,
    }) => {
      const image = document.createElement('img');
      image.alt = alt;
      image.className = className;
      image.decoding = 'async';
      image.height = height;
      image.loading = 'lazy';
      image.src = src;
      image.width = width;
      if (srcset) image.srcset = srcset;
      if (sizes) image.sizes = sizes;
      return image;
    };

    const getResponsiveProductImageSource = (src) => {
      const fallback = { src };

      try {
        const url = new URL(src, window.location.href);
        const isShopifyCdnImage =
          url.hostname === 'cdn.shopify.com' ||
          (url.hostname.endsWith('.myshopify.com') && url.pathname.includes('/cdn/'));

        if (!isShopifyCdnImage) return fallback;

        const widths = [100, 200];
        const buildUrl = (width) => {
          const imageUrl = new URL(url.href);
          imageUrl.searchParams.set('width', String(width));
          return imageUrl.toString();
        };

        return {
          src: buildUrl(200),
          srcset: widths.map((width) => `${buildUrl(width)} ${width}w`).join(', '),
          sizes: '100px',
        };
      } catch {
        return fallback;
      }
    };

    const normalizeIdentifier = (value) => String(value || '').trim().toLowerCase();
    const allowedProductIds = [productId, fallbackProductId, ...configuredProductIds]
      .map(normalizeIdentifier)
      .filter(Boolean);
    const allowedProductHandles = [productHandle, fallbackProductHandle]
      .map(normalizeIdentifier)
      .filter(Boolean);

    const matchesScopedProduct = (review) => {
      if (!allowedProductIds.length && !allowedProductHandles.length) return true;

      const product = review && review.product && typeof review.product === 'object' ? review.product : {};
      const externalId = normalizeIdentifier(product.externalId);
      const handle = normalizeIdentifier(product.handle);

      return (
        (externalId && allowedProductIds.includes(externalId)) ||
        (handle && allowedProductHandles.includes(handle))
      );
    };

    // Cards need a quote; the wall's short chips need a sentence, not a two-word remark.
    const minBodyLength = isWall ? 20 : 1;
    const isDisplayableReview = (review) =>
      matchesScopedProduct(review) &&
      String(review?.body || '').trim().length >= minBodyLength &&
      !/intentional QA content/i.test(String(review?.body || ''));

    const createReviewCard = (review) => {
      const card = document.createElement('article');
      const top = document.createElement('div');
      const stars = document.createElement('span');
      const emptyStars = createImage({
        className: 'trufit-reviews__card-stars-empty',
        height: 18,
        src: starUrl,
        width: 108,
      });
      const filledStars = document.createElement('span');
      const product = review && review.product && typeof review.product === 'object' ? review.product : {};
      const rating = Math.max(0, Math.min(5, Number(review?.rating) || 0));
      const ratingPercentage = (rating / 5) * 100;

      card.className = 'trufit-reviews__card';
      card.dataset.reviewCard = '';
      top.className = 'trufit-reviews__top';
      stars.className = 'trufit-reviews__card-stars';
      stars.style.setProperty(
        '--trufit-reviews-rating-percent',
        String(ratingPercentage) + '%'
      );
      stars.setAttribute('role', 'img');
      stars.setAttribute(
        'aria-label',
        ratingLabelTemplate.replace('__rating__', String(rating))
      );
      filledStars.className = 'trufit-reviews__card-stars-filled';
      filledStars.setAttribute('aria-hidden', 'true');
      filledStars.append(
        createImage({
          height: 18,
          src: starUrl,
          width: 108,
        })
      );
      stars.append(emptyStars, filledStars);
      top.append(stars);

      if (!isWall) {
        const tag = document.createElement('span');
        tag.className = 'trufit-reviews__tag';
        tag.textContent = shortTagName(product.title || productFallbackLabel);
        top.append(tag);
      }

      card.append(top);

      const quote = document.createElement('p');
      quote.className = 'trufit-reviews__quote';
      quote.textContent = review?.body || '';
      if (!review?.body) quote.setAttribute('aria-hidden', 'true');
      card.append(quote);

      const footer = document.createElement('footer');
      const identity = document.createElement('div');
      const author = document.createElement('strong');
      const productName = document.createElement('span');

      footer.className = 'trufit-reviews__footer';
      author.textContent = formatReviewerName(review?.reviewerName) || anonymousLabel;
      identity.append(author);
      if (isWall) {
        productName.className = 'trufit-reviews__meta';
        productName.textContent = ' · ' + (product.title || productFallbackLabel);
        identity.append(productName);
      }
      footer.append(identity);

      if (!isWall && checkUrl && verifiedLabel) {
        const verified = document.createElement('span');
        verified.className = 'trufit-reviews__verified';
        verified.append(
          createImage({
            height: 16,
            src: checkUrl,
            width: 16,
          }),
          document.createTextNode(verifiedLabel)
        );
        footer.append(verified);
      }

      card.append(footer);
      return card;
    };

    const displayStatus = (message, isError = false) => {
      const status = document.createElement('p');
      status.className = 'trufit-reviews__status';
      status.dataset.reviewsStatus = '';
      status.setAttribute('role', isError ? 'alert' : 'status');
      status.textContent = message;

      if (isError) status.classList.add('trufit-reviews__status--error');

      track.replaceChildren(status);
      cards = [];
      if (navigation instanceof HTMLElement) navigation.hidden = true;
    };

    const getTrackInlineInset = () =>
      Number.parseFloat(window.getComputedStyle(track).paddingInlineStart) || 0;

    const getMetrics = () => {
      const firstCard = cards[0];
      const secondCard = cards[1];

      if (!firstCard) {
        return {
          currentCard: 0,
          maxStartIndex: 0,
          visibleCards: 0,
        };
      }

      const cardStep = secondCard
        ? secondCard.offsetLeft - firstCard.offsetLeft
        : firstCard.offsetWidth;
      const trackInlineInset = getTrackInlineInset();
      const visibleCards = Math.max(1, Math.round(track.clientWidth / Math.max(cardStep, 1)));
      const currentCard = cards.reduce((closestIndex, card, index) => {
        const currentDistance = Math.abs(
          cards[closestIndex].offsetLeft - track.offsetLeft - trackInlineInset - track.scrollLeft
        );
        const nextDistance = Math.abs(
          card.offsetLeft - track.offsetLeft - trackInlineInset - track.scrollLeft
        );
        return nextDistance < currentDistance ? index : closestIndex;
      }, 0);

      return {
        currentCard,
        maxStartIndex: Math.max(0, cards.length - visibleCards),
        visibleCards,
      };
    };

    const updateControls = () => {
      if (!cards.length || isWall) return;

      const { currentCard, maxStartIndex, visibleCards } = getMetrics();
      const atStart = currentCard <= 0;
      const atEnd = currentCard >= maxStartIndex;
      const hasOverflow = track.scrollWidth > track.clientWidth + 1;
      const start = Math.min(currentCard + 1, cards.length);
      const end = Math.min(currentCard + visibleCards, cards.length);

      if (navigation instanceof HTMLElement) {
        navigation.hidden = !(hasOverflow || hasMore);
      }
      if (previousButton instanceof HTMLButtonElement) {
        previousButton.disabled = isLoading || atStart;
      }
      if (nextButton instanceof HTMLButtonElement) {
        nextButton.disabled = isLoading || (!hasMore && atEnd);
      }
      if (position instanceof HTMLElement) {
        position.textContent = positionLabelTemplate
          .replace('__start__', String(start))
          .replace('__end__', String(end));
      }

      maybePrefetchNextPage();
    };

    const isPhoneLayout = () => window.matchMedia('(max-width: 749px)').matches;

    const cloneWallCard = (card) => {
      const copy = card.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-wall-duplicate', '');
      delete copy.dataset.reviewCard;
      return copy;
    };

    // Desktop marquee: each strip must be wider than the screen (wide monitors showed white space), then a
    // copy of the strip follows so the loop has no seam. Phones swipe the real cards instead, with no copies.
    const fillWallRows = () => {
      const rows = Array.from(track.querySelectorAll('.trufit-reviews__wall-row'));
      rows.forEach((row) => {
        row.querySelectorAll('[data-wall-duplicate]').forEach((element) => element.remove());
        const strip = row.querySelector('.trufit-reviews__wall-track');
        if (!(strip instanceof HTMLElement)) return;
        if (isPhoneLayout()) {
          row.style.removeProperty('--trufit-wall-duration');
          if (!phoneAutoScrollAllowed()) return;
          const phoneOriginals = Array.from(strip.querySelectorAll('[data-review-card]'));
          const longest = Math.max(...rows.map((r) => r.querySelectorAll('.trufit-reviews__wall-track [data-review-card]').length));
          let pad = 0;
          while (phoneOriginals.length && strip.children.length < longest && pad < 4) {
            strip.append(cloneWallCard(phoneOriginals[pad % phoneOriginals.length]));
            pad += 1;
          }
          const phoneCopy = strip.cloneNode(true);
          phoneCopy.setAttribute('aria-hidden', 'true');
          phoneCopy.setAttribute('data-wall-duplicate', '');
          phoneCopy.querySelectorAll('[data-review-card]').forEach((card) => {
            delete card.dataset.reviewCard;
          });
          row.append(phoneCopy);
          return;
        }
        const originals = Array.from(strip.querySelectorAll('[data-review-card]'));
        const minimumWidth = track.clientWidth + 400;
        let safety = 0;
        while (originals.length && strip.scrollWidth < minimumWidth && safety < 12) {
          originals.forEach((card) => strip.append(cloneWallCard(card)));
          safety += 1;
        }
        const duplicate = strip.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        duplicate.setAttribute('data-wall-duplicate', '');
        duplicate.querySelectorAll('[data-review-card]').forEach((card) => {
          delete card.dataset.reviewCard;
        });
        row.append(duplicate);
        row.style.setProperty('--trufit-wall-duration', String(Math.max(40, strip.children.length * 9)) + 's');
      });
    };

    // Phones: slow auto-scroll through the wall; a finger swipe takes over and auto-scroll resumes shortly after.
    const phoneAutoScrollAllowed = () => isPhoneLayout() && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const wallAuto = { running: false, paused: false, visible: true, pos: 0, last: 0, resumeTimer: 0, bound: false };
    const wallPeriod = () => {
      const first = track.querySelector('.trufit-reviews__wall-row .trufit-reviews__wall-track');
      return first instanceof HTMLElement ? first.offsetWidth : 0;
    };
    const wallTick = (now) => {
      if (!wallAuto.running) return;
      const dt = wallAuto.last ? Math.min(64, now - wallAuto.last) : 16;
      wallAuto.last = now;
      if (!wallAuto.paused && wallAuto.visible) {
        const period = wallPeriod();
        wallAuto.pos += dt * 0.035;
        if (period > 0 && wallAuto.pos >= period) wallAuto.pos -= period;
        track.scrollTo({ left: wallAuto.pos, behavior: 'instant' });
      }
      window.requestAnimationFrame(wallTick);
    };
    const wallPause = () => {
      wallAuto.paused = true;
      window.clearTimeout(wallAuto.resumeTimer);
    };
    const wallResumeSoon = () => {
      window.clearTimeout(wallAuto.resumeTimer);
      wallAuto.resumeTimer = window.setTimeout(() => {
        const period = wallPeriod();
        wallAuto.pos = track.scrollLeft;
        if (period > 0 && wallAuto.pos >= period) wallAuto.pos -= period;
        wallAuto.paused = false;
      }, 2000);
    };
    const startPhoneAutoScroll = () => {
      const allowed = phoneAutoScrollAllowed();
      section.classList.toggle('trufit-reviews--wall-autoscroll', allowed);
      if (!allowed) {
        wallAuto.running = false;
        return;
      }
      if (!wallAuto.bound) {
        wallAuto.bound = true;
        track.addEventListener('touchstart', wallPause, { passive: true });
        track.addEventListener('pointerdown', wallPause);
        track.addEventListener('touchend', wallResumeSoon, { passive: true });
        track.addEventListener('touchcancel', wallResumeSoon, { passive: true });
        track.addEventListener('pointerup', wallResumeSoon);
        track.addEventListener('wheel', () => { wallPause(); wallResumeSoon(); }, { passive: true });
        track.addEventListener('scroll', () => {
          if (!wallAuto.paused) return;
          const period = wallPeriod();
          if (period > 0 && track.scrollLeft >= period) track.scrollTo({ left: track.scrollLeft - period, behavior: 'instant' });
          wallResumeSoon();
        }, { passive: true });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            wallAuto.visible = entries.some((entry) => entry.isIntersecting);
          }).observe(track);
        }
      }
      wallAuto.pos = track.scrollLeft;
      if (!wallAuto.running) {
        wallAuto.running = true;
        wallAuto.last = 0;
        window.requestAnimationFrame(wallTick);
      }
    };

    // Spread reviews out so the same product is never next to itself in a row (positions i and i+2)
    // and, when there is enough variety, not straight above or below itself either (i and i+1).
    const spreadByProduct = (reviews) => {
      const keyOf = (review) => {
        const product = review && review.product && typeof review.product === 'object' ? review.product : {};
        return String(product.id || product.handle || product.title || '');
      };
      const groups = new Map();
      reviews.forEach((review) => {
        const key = keyOf(review);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(review);
      });
      if (groups.size < 2) return reviews;
      const out = [];
      while (out.length < reviews.length) {
        const last1 = out.length > 0 ? keyOf(out[out.length - 1]) : null;
        const last2 = out.length > 1 ? keyOf(out[out.length - 2]) : null;
        const open = Array.from(groups.entries()).filter((entry) => entry[1].length);
        const pick = (avoid) => open.filter((entry) => !avoid.includes(entry[0])).sort((x, y) => y[1].length - x[1].length)[0];
        const choice = pick([last1, last2]) || pick([last2]) || pick([]);
        out.push(choice[1].shift());
      }
      return out;
    };

    const renderWall = (reviews) => {
      const rows = [[], []];
      spreadByProduct(reviews).forEach((review, index) => rows[index % 2].push(review));
      const fragment = document.createDocumentFragment();

      rows.forEach((rowReviews, rowIndex) => {
        if (!rowReviews.length) return;
        const row = document.createElement('div');
        const strip = document.createElement('div');
        row.className = 'trufit-reviews__wall-row';
        row.dataset.wallRow = String(rowIndex);
        strip.className = 'trufit-reviews__wall-track';
        rowReviews.forEach((review) => strip.append(createReviewCard(review)));
        row.append(strip);
        fragment.append(row);
      });

      track.replaceChildren(fragment);
      cards = Array.from(track.querySelectorAll('[data-review-card]'));
      fillWallRows();
      startPhoneAutoScroll();
    };

    if (isWall) {
      let wallResizeTimer = 0;
      let wallLastWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth === wallLastWidth) return;
        wallLastWidth = window.innerWidth;
        window.clearTimeout(wallResizeTimer);
        wallResizeTimer = window.setTimeout(() => {
          fillWallRows();
          startPhoneAutoScroll();
        }, 200);
      });
    }

    const renderReviews = (reviews) => {
      if (isWall) {
        renderWall(reviews);
        return;
      }
      const fragment = document.createDocumentFragment();
      reviews.forEach((review) => fragment.append(createReviewCard(review)));
      track.replaceChildren(fragment);
      cards = Array.from(track.querySelectorAll('[data-review-card]'));
      track.scrollLeft = 0;
    };

    const appendReviews = (reviews) => {
      const fragment = document.createDocumentFragment();
      reviews.forEach((review) => fragment.append(createReviewCard(review)));
      track.append(fragment);
      cards = Array.from(track.querySelectorAll('[data-review-card]'));
    };

    const defaultScopedProductId = configuredProductIds.length ? configuredProductIds.join(',') : productId;

    const fetchReviewData = async (page, scopedProductId = defaultScopedProductId) => {
      const url = new URL(apiUrl, window.location.origin);
      url.searchParams.set('page', String(page));
      url.searchParams.set('per_page', String(perPage));
      url.searchParams.set('min_rating', String(minRating));
      if (scopedProductId) url.searchParams.set('shopifyProductId', scopedProductId);

      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('reviews-request-failed');

      const data = await response.json();
      if (hiddenReviewIds.length && data && Array.isArray(data.reviews)) {
        data.reviews = data.reviews.filter((review) => !hiddenReviewIds.includes(String(review && review.id)));
      }
      return data;
    };

    const loadInitialReviews = async () => {
      if (isLoading || !apiUrl) {
        if (!apiUrl) {
          displayStatus(section.dataset.reviewsError || '', true);
          track.setAttribute('aria-busy', 'false');
        }
        return;
      }

      isLoading = true;
      track.setAttribute('aria-busy', 'true');
      updateControls();

      try {
        activeScopedProductId = defaultScopedProductId;
        let data = await fetchReviewData(1, activeScopedProductId);
        let reviews = Array.isArray(data?.reviews) ? data.reviews.filter(isDisplayableReview) : [];

        if (!reviews.length && fallbackProductId && fallbackProductId !== productId) {
          activeScopedProductId = fallbackProductId;
          data = await fetchReviewData(1, activeScopedProductId);
          reviews = Array.isArray(data?.reviews) ? data.reviews.filter(isDisplayableReview) : [];
        }

        if (!reviews.length) {
          section.hidden = true;
          displayStatus(section.dataset.reviewsEmpty || '');
          return;
        }

        apiPage = Number(data.current_page) || 1;
        hasMore = !isWall && Boolean(data.has_more);
        renderReviews(reviews);
        section.hidden = false;
      } catch {
        section.hidden = false;
        displayStatus(section.dataset.reviewsError || '', true);
      } finally {
        isLoading = false;
        track.setAttribute('aria-busy', 'false');
        updateControls();
      }
    };

    const loadMoreReviews = async () => {
      if (isLoading || !hasMore || !apiUrl) return;

      isLoading = true;
      track.setAttribute('aria-busy', 'true');
      updateControls();

      try {
        const nextPage = apiPage + 1;
        const data = await fetchReviewData(nextPage, activeScopedProductId);
        const reviews = Array.isArray(data?.reviews) ? data.reviews.filter(isDisplayableReview) : [];

        if (reviews.length) {
          appendReviews(reviews);
          apiPage = Number(data.current_page) || nextPage;
        }

        hasMore = Boolean(data?.has_more) && reviews.length > 0;
      } catch {
        hasMore = false;
      } finally {
        isLoading = false;
        track.setAttribute('aria-busy', 'false');
        updateControls();
      }
    };

    const maybePrefetchNextPage = () => {
      if (!hasMore || isLoading || !cards.length) return;

      const { currentCard, maxStartIndex, visibleCards } = getMetrics();
      const slidesRemaining = Math.ceil((maxStartIndex - currentCard) / Math.max(visibleCards, 1));

      if (slidesRemaining <= prefetchSlidesThreshold) {
        loadMoreReviews();
      }
    };

    const scrollPage = (direction) => {
      const { currentCard, maxStartIndex, visibleCards } = getMetrics();
      const targetIndex = Math.max(
        0,
        Math.min(maxStartIndex, currentCard + direction * visibleCards)
      );
      const targetCard = cards[targetIndex];

      if (!targetCard) return;

      track.scrollTo({
        left: targetCard.offsetLeft - track.offsetLeft - getTrackInlineInset(),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    previousButton?.addEventListener('click', () => {
      scrollPage(-1);
    });

    nextButton?.addEventListener('click', () => {
      const { currentCard, maxStartIndex } = getMetrics();

      if (currentCard < maxStartIndex) {
        scrollPage(1);
      } else if (hasMore && !isLoading) {
        loadMoreReviews().then(() => scrollPage(1));
      }
    });

    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updateControls);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateControls).observe(track);
    } else {
      window.addEventListener('resize', updateControls);
    }

    // "Write a review" popup: product picker + form, submitted to Judge.me the same way its own storefront
    // widget does (public create endpoint, no API token), so the customer never leaves the site.
    const modal = section.querySelector('[data-reviews-modal]');
    const openButtons = Array.from(section.querySelectorAll('[data-reviews-write]'));

    if (modal instanceof HTMLElement && openButtons.length) {
      const dialog = modal.querySelector('.trufit-reviews__modal-dialog');
      const form = modal.querySelector('[data-reviews-form]');
      const formStatus = modal.querySelector('[data-reviews-form-status]');
      const successPanel = modal.querySelector('[data-reviews-form-success]');
      const submitButton = modal.querySelector('[data-reviews-submit]');
      const submitLabel = modal.dataset.reviewsFormSubmit || '';
      const submittingLabel = modal.dataset.reviewsFormSubmitting || submitLabel;
      const requiredMessage = modal.dataset.reviewsFormRequired || '';
      const errorMessage = modal.dataset.reviewsFormError || '';
      let lastFocused = null;
      let isSubmitting = false;

      const setFormStatus = (message) => {
        if (!(formStatus instanceof HTMLElement)) return;
        formStatus.textContent = message;
        formStatus.hidden = !message;
      };

      const getFocusable = () =>
        Array.from(
          dialog.querySelectorAll(
            'a[href], button:not([disabled]), input:not([type="hidden"]):not([tabindex="-1"]), select, textarea, [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => element.offsetParent !== null);

      const onKeydown = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = getFocusable();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      const openModal = () => {
        lastFocused = document.activeElement;
        if (form instanceof HTMLFormElement) form.hidden = false;
        if (successPanel instanceof HTMLElement) successPanel.hidden = true;
        setFormStatus('');
        modal.hidden = false;
        document.body.classList.add('trufit-reviews-modal-open');
        document.addEventListener('keydown', onKeydown);
        window.requestAnimationFrame(() => {
          modal.classList.add('is-open');
          const firstField = form instanceof HTMLFormElement ? form.querySelector('select, input, textarea') : null;
          (firstField || dialog).focus();
        });
      };

      const closeModal = () => {
        modal.classList.remove('is-open');
        modal.hidden = true;
        document.body.classList.remove('trufit-reviews-modal-open');
        document.removeEventListener('keydown', onKeydown);
        if (lastFocused instanceof HTMLElement) lastFocused.focus();
      };

      openButtons.forEach((button) => button.addEventListener('click', openModal));
      // Links like /products/mouthguard#write-review (sport pages) open the form straight away.
      if (window.location.hash === '#write-review') {
        section.scrollIntoView({ block: 'start' });
        window.setTimeout(openModal, 300);
      }
      modal.querySelectorAll('[data-reviews-modal-close]').forEach((button) => {
        button.addEventListener('click', closeModal);
      });

      if (form instanceof HTMLFormElement) {
        const fieldOf = (control) => control.closest('.trufit-reviews__field');

        form.addEventListener('input', (event) => {
          const field = event.target instanceof Element ? fieldOf(event.target) : null;
          if (field) field.classList.remove('is-invalid');
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (isSubmitting) return;

          const honeypot = form.querySelector('[name="website"]');
          if (honeypot instanceof HTMLInputElement && honeypot.value) {
            form.hidden = true;
            if (successPanel instanceof HTMLElement) successPanel.hidden = false;
            return;
          }

          form.querySelectorAll('.is-invalid').forEach((field) => field.classList.remove('is-invalid'));
          const invalid = Array.from(form.querySelectorAll(':invalid'));
          if (invalid.length) {
            invalid.forEach((control) => fieldOf(control)?.classList.add('is-invalid'));
            setFormStatus(requiredMessage);
            const firstInvalid = invalid.find((control) => control.type !== 'radio') || invalid[0];
            const target = firstInvalid.type === 'radio' ? form.querySelector('[data-reviews-rating] label') : firstInvalid;
            if (target instanceof HTMLElement) target.focus();
            return;
          }

          const value = (name) => {
            const control = form.querySelector('[name="' + name + '"]:not([type="radio"])');
            return control && 'value' in control ? String(control.value).trim() : '';
          };
          const rating = form.querySelector('[name="rating"]:checked');
          const payload = new FormData();
          const shopDomain = form.dataset.reviewsShopDomain || '';
          payload.append('url', shopDomain);
          payload.append('shop_domain', shopDomain);
          payload.append('platform', form.dataset.reviewsPlatform || 'shopify');
          payload.append('id', value('id'));
          payload.append('rating', rating instanceof HTMLInputElement ? rating.value : '');
          payload.append('name', value('name'));
          payload.append('email', value('email'));
          if (value('title')) payload.append('title', value('title'));
          payload.append('body', value('body'));

          isSubmitting = true;
          setFormStatus('');
          if (submitButton instanceof HTMLButtonElement) {
            submitButton.disabled = true;
            submitButton.textContent = submittingLabel;
          }

          try {
            const response = await fetch(form.dataset.reviewsSubmitUrl || '', {
              method: 'POST',
              body: payload,
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) throw new Error('review-submit-failed');
            form.reset();
            form.hidden = true;
            if (successPanel instanceof HTMLElement) {
              successPanel.hidden = false;
              successPanel.querySelector('button')?.focus();
            }
          } catch {
            setFormStatus(errorMessage);
          } finally {
            isSubmitting = false;
            if (submitButton instanceof HTMLButtonElement) {
              submitButton.disabled = false;
              submitButton.textContent = submitLabel;
            }
          }
        });
      }
    }

    loadInitialReviews();
  };

  const initializeJudgeMeReviewSections = (root = document) => {
    if (root instanceof HTMLElement && root.matches('[data-trufit-reviews]')) {
      initializeJudgeMeReviewSection(root);
    }

    root.querySelectorAll?.('[data-trufit-reviews]').forEach(initializeJudgeMeReviewSection);
  };

  initializeJudgeMeReviewSections();
  document.addEventListener('shopify:section:load', (event) => initializeJudgeMeReviewSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topline-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(value).padStart(2, "0");
    const formatCountdown = (deadline) => {
      const deadlineTime = new Date(deadline).getTime();

      if (!deadline || Number.isNaN(deadlineTime)) {
        return "00D : 00H : 00M : 00S";
      }

      const diff = Math.max(deadlineTime - Date.now(), 0);
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      return `${pad(days)}D : ${pad(hours)}H : ${pad(minutes)}M : ${pad(seconds)}S`;
    };

    document.querySelectorAll("[data-trufit-locale-menu]").forEach((menu) => {
      document.addEventListener("click", (event) => {
        if (menu.open && !menu.contains(event.target)) {
          menu.removeAttribute("open");
        }
      });
      menu.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && menu.open) {
          menu.removeAttribute("open");
          const toggle = menu.querySelector("summary");
          if (toggle) toggle.focus();
        }
      });
    });

    document.querySelectorAll("[data-trufit-countdown]").forEach((node) => {
      const output = node.querySelector("[data-trufit-countdown-value]");
      const deadline = node.dataset.deadline;

      if (!output) {
        return;
      }

      const update = () => {
        output.textContent = formatCountdown(deadline);
      };

      update();
      window.setInterval(update, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workflow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carousel = document.getElementById('workflowCarousel');
    const dots = document.querySelectorAll('.workflow__tabs-item');
    const cards = document.querySelectorAll('.workflow__card');
    let currentIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let isAnimating = false;

    function getCardWidth() {
      return cards[0].offsetWidth;
    }

    function updateCarousel(index, animate = true) {
      if (window.innerWidth > 768) return;
      if (isAnimating) return;

      const cardWidth = getCardWidth();
      const offset = -(index * cardWidth);

      if (animate) {
        carousel.style.transition = 'transform 0.5s ease';
      } else {
        carousel.style.transition = 'none';
      }

      carousel.style.transform = `translateX(${offset}px)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle('workflow__tabs-item--active', i === index);
      });

      currentIndex = index;

      if (!animate) {
        setTimeout(() => {
          carousel.style.transition = 'transform 0.5s ease';
        }, 50);
      }
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', function () {
        if (window.innerWidth <= 768 && index !== currentIndex) {
          updateCarousel(index);
        }
      });
    });

    carousel.addEventListener(
      'touchstart',
      function (e) {
        if (window.innerWidth > 768) return;
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchmove',
      function (e) {
        if (window.innerWidth > 768) return;
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchend',
      function (e) {
        if (window.innerWidth > 768) return;

        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        const cardWidth = getCardWidth();

        if (Math.abs(diff) > 50) {
          if (diff > 0 && currentIndex < cards.length - 1) {
            updateCarousel(currentIndex + 1);
          } else if (diff < 0 && currentIndex > 0) {
            updateCarousel(currentIndex - 1);
          }
        }
      },
      { passive: true }
    );

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth > 768) {
          carousel.style.transition = 'none';
          carousel.style.transform = 'translateX(0)';
          dots.forEach((dot, i) => {
            dot.classList.toggle('workflow__tabs-item--active', i === 0);
          });
          currentIndex = 0;
          setTimeout(() => {
            carousel.style.transition = 'transform 0.5s ease';
          }, 50);
        } else {
          const cardWidth = getCardWidth();
          const offset = -(currentIndex * cardWidth);
          carousel.style.transition = 'none';
          carousel.style.transform = `translateX(${offset}px)`;
          setTimeout(() => {
            carousel.style.transition = 'transform 0.5s ease';
          }, 50);
        }
      }, 250);
    });

    if (window.innerWidth <= 768) {
      carousel.style.transition = 'none';
      const cardWidth = getCardWidth();
      carousel.style.transform = `translateX(0px)`;
      setTimeout(() => {
        carousel.style.transition = 'transform 0.5s ease';
      }, 50);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
